module.exports = __webpack_public_path__ + "static/media/deg.4b18c661.png";